/*eslint-disable*/
import easydropdown from 'easydropdown'
export default form => {
	$(document).ready(() => {
    let $form = $(form)
		let url = 'https://script.google.com/macros/s/AKfycbx6U4kzp07JPA0Hnvnv457K8XLg4iQeiowWZrfBKbGsRavp6Z0/exec'
		$form.on('submit', e => {
			$form.find('.contact-field').each((idx, contactField)=>{
				if(!$(contactField).hasClass('selected')){
					$(contactField).removeAttr('disabled')
				} 
			})
			e.preventDefault();
			const surveyPost = $.ajax({
				url: url,
				method: "GET",
				dataType: "json",
				data: serializeJqueryObject($form),
				success: data => {
					$('.personal-gift-shopper-form-holder').addClass('hide');
					$('.personal-gift-shopper-form-holder.thanks').removeClass('hide');
				},
				error: error => {
					console.error(error)
				}
			})
		})

		const selectMenues = form.querySelectorAll('select')
		selectMenues.forEach((sel, idx)=>{
			if (sel) {
				let edd = easydropdown(sel, {
					behavior: {
						useNativeUiOnMobile: false,
						showPlaceholderWhenOpen: true,
						liveUpdates: true,
					},
					classNames: {
						rootOpenBelow: true,
						rootOpenBelow: 'edd-root-open-below'
					},
					callbacks: {
						onOpen: value => {
							$('.edd-root').removeClass('edd-root-open-above').addClass('edd-root-open-below')
						},
						onSelect: value => {
							$(form).find('.contact-field').each((idx, contactField)=>{
								$(contactField).removeClass('selected').removeAttr('required')
								$(contactField).attr('id') === value.toLowerCase() && $(contactField).addClass('selected').attr('required', true)
								
							})
						}
					}
				})
			}
		})

		$form.find('.contact-dropdown').change(e => $(e.target).css('color', 'black'))
		$('input#preference-email').click(()=>{
			$('input#email').removeClass('hidden').attr('required', true).val('')
			$('input#phone').addClass('hidden').attr('required', false).val('NA')
		})

		$('input#preference-phone').click(()=>{
			$('input#phone').removeClass('hidden').attr('required', true).val('')
			$('input#email').addClass('hidden').attr('required', false).val('NA')
		})
		$('.preference-budget').each((idx, budgetOption)=>{
			$(budgetOption).click(()=>$('#preference-budget').val($(budgetOption).val()))
		})

		$('.scrollToForm').click((e) => {
			e.preventDefault()
			$('html, body').animate({
				scrollTop: $("#personal-gift-shopper #apply").offset().top - 50
			}, 1100)
		})
})

	const serializeJqueryObject = $form => {
		let obj = {};
		let array = $form.serializeArray();
		array.forEach((entry, idx) => {
			if (obj[entry.name]) {
				if (!obj[entry.name].push) obj[entry.name] = [obj[entry.name]]
				obj[entry.name].push(entry.value || '')
			} else obj[entry.name] = entry.value || ''
		});
		return obj;
	};
}


// WEBPACK FOOTER //
// ./src/scripts/components/personal-gift-shopper-form.js